import { FC, ComponentProps, ReactNode } from "react";
import styled from "styled-components";
import { StyledButton } from "./PrimaryButton";
import { StyledDangerButton } from "./DangerButton";
import { WhiteIcon } from "../Icon";
import { ButtonVariant } from "./types";
import { BaseComponentProps } from "../types";

const StyledIconButton = styled(StyledButton)`
  display: inline-flex;
  padding: 3px;
`;
const StyledDangerIconButton = styled(StyledDangerButton)`
  padding: 3px;
`;

type IconButtonProps = BaseComponentProps<
  "button",
  {
    children?: ReactNode;
    /** Icon to render. */
    iconName: ComponentProps<typeof WhiteIcon>["iconName"];

    /** Icon to render on the right side. */
    secondaryIconName?: ComponentProps<typeof WhiteIcon>["iconName"];
    variant?: ButtonVariant;
  }
>;

const IconButtonWrapper = ({
  variant,
  children,
  ...buttonProps
}: IconButtonProps) => {
  if (variant === ButtonVariant.DANGER) {
    return (
      <StyledDangerIconButton {...buttonProps} variant={variant}>
        {children}
      </StyledDangerIconButton>
    );
  } else {
    return (
      <StyledIconButton {...buttonProps} variant={variant}>
        {children}
      </StyledIconButton>
    );
  }
};

export const IconButton: FC<IconButtonProps> = ({
  iconName,
  secondaryIconName,
  variant = ButtonVariant.DEFAULT,
  disabled = false,
  ...buttonProps
}) => {
  return (
    <IconButtonWrapper
      {...buttonProps}
      iconName={iconName}
      secondaryIconName={secondaryIconName}
      variant={variant}
      disabled={variant === ButtonVariant.DISABLED || disabled}
    >
      <WhiteIcon iconName={iconName} />
      {secondaryIconName && (
        <WhiteIcon iconName={secondaryIconName} iconSize="small" />
      )}
    </IconButtonWrapper>
  );
};
